// Animated number that counts up to ``value`` whenever ``value`` changes.
// Keeps original markup minimal — drop-in replacement for any inline number.
//
// Examples:
//   <Counter value={67.4} decimals={1} suffix="%" />
//   <Counter value={odd} decimals={2} prefix="" />

import { useEffect, useRef } from "react";
import { countTo } from "@/lib/motion";

export default function Counter({
  value,
  from = 0,
  decimals = 0,
  suffix = "",
  prefix = "",
  duration = 900,
  delay = 0,
  className,
  style,
  testid,
  kachunk = false,
  glowColor,
  as: Tag = "span",
}) {
  const ref = useRef(null);
  const prev = useRef(from);

  useEffect(() => {
    if (!ref.current || value == null || isNaN(value)) return;
    const inst = countTo(ref.current, +value, {
      from: prev.current, decimals, suffix, prefix, duration, delay,
      kachunk, glowColor,
    });
    prev.current = +value;
    return () => { inst?.cancel?.(); };
  }, [value, decimals, suffix, prefix, duration, delay, kachunk, glowColor]);

  // SSR / first-paint fallback so the slot isn't empty
  const initial = `${prefix}${(+from).toFixed(decimals)}${suffix}`;
  return (
    <Tag ref={ref} className={className} style={style} data-testid={testid}>
      {initial}
    </Tag>
  );
}
